/**
 * The numbers the meta screens print. Hand-rolled rather than
 * `Intl.NumberFormat` because these strings are asserted in tests and `Intl`'s
 * output depends on the host's ICU data.
 */

/**
 * `1234` → `"1,234"`, rounded and grouped in thousands — the counter behind
 * `formatEuros`, and used bare for quantities (xp, the lifetime tally) so one
 * screen has one convention.
 */
export function formatCount(n: number): string {
  const rounded = Number.isFinite(n) ? Math.round(n) : 0;
  const sign = rounded < 0 ? "−" : "";
  const digits = String(Math.abs(rounded));

  let grouped = "";
  for (let i = 0; i < digits.length; i++) {
    // A separator before every digit whose distance from the end is a multiple
    // of three — i.e. between thousands, and never in front of the number.
    if (i > 0 && (digits.length - i) % 3 === 0) grouped += ",";
    grouped += digits[i];
  }
  return `${sign}${grouped}`;
}

/** `1234` → `"€1,234"`. Rounded to the whole Euro; the game has no cents. */
export function formatEuros(n: number): string {
  const rounded = Number.isFinite(n) ? Math.round(n) : 0;
  return rounded < 0 ? `−€${formatCount(-rounded)}` : `€${formatCount(rounded)}`;
}

/**
 * Milliseconds → `"m:ss"`, floored, never negative — both the raid timer and
 * the queue countdown. Minutes are NOT zero-padded: "0:08" rather than "00:08".
 */
export function formatMmSs(ms: number): string {
  const total = Number.isFinite(ms) && ms > 0 ? Math.floor(ms / 1000) : 0;
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
}
